export default __webpack_public_path__ + "static/media/dark_blue_scribble.2a44449f.png";